export const iconFontAwesomeMediaplaybackCirclePlay = (
	<i className="fa-solid fa-circle-play"></i>
);
